<template>
  <div style="position: relative" :style="buttonStyle">
    <div class="laptop-frame">
      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s" />
    </div>
    <div class="laptop-body" style="font-family: inherit">
      <div
        class="header-mob"
        :style="`color:${primaryTextColor}; display:flex; align-items:center; padding:8px 16px;`"
      >
        <!-- Logo -->
        <div style="display: flex; align-items: center">
          <div class="app-logo">
            <img
              :src="appIcon || require('@/assets/images/mob-default-img.svg')"
              alt="Logo"
            />
          </div>
          <div style="margin-right: 10px; margin-left: 2px">
            <b>{{ appName }}</b>
            <p style="margin: 0; font-size: 7px; font-weight: bold">
              {{ tagLine }}
            </p>
          </div>
        </div>

        <!-- Search Bar -->
        <div
          style="
            flex: 1;
            display: flex;
            align-items: center;
            border: 1px solid #e0e0e0;
            border-radius: 5px;
            overflow: hidden;
            background-color: white;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            max-width: 200px;
            max-height: 26px;
            margin: 0 auto;
          "
        >
          <div style="padding: 0 8px; color: #999">
            <svg
              width="11"
              height="11"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
          </div>
          <input
            type="text"
            placeholder="Search for fresh fruits & vegetables..."
            style="
              border: none;
              outline: none;
              flex: 1;
              padding: 12px 0;
              font-size: 6px;
              color: #333;
            "
          />
          <button
            :style="`background:${primaryColor};`"
            style="
              border: none;
              padding: 2px 5px;
              margin: 2px;
              background-color: #4caf50;
              color: white;
              font-weight: bold;
              cursor: pointer;
              border-radius: 5px;
            "
          >
            <svg
              width="9"
              height="9"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
          </button>
        </div>

        <!-- Icons -->
        <div
          class="header-icons"
          style="
            display: flex;
            align-items: center;
            gap: 12px;
            color: #1e293b;
            margin-left: 12px;
          "
        >
          <div class="flex justify-content-center align-items-center">
            <div class="account-icon">
              <i class="fas fa-user"></i>
            </div>
            <div style="font-size: 7px">
              <p style="margin: 0">Hello, SignIn</p>
              <b style="margin: 0">Account & Lists</b>
              <!-- <p style="margin: 0; font-size: 7px">Hello, SignIn</p>
            <b style="margin: 0; font-size: 6px">Account & Lists</b> -->
            </div>
          </div>
          <div
            class="flex flex-column justify-content-center align-items-center"
          >
            <i
              v-if="headerWishlistIcon"
              class="fa fa-heart"
              style="font-size: 10px"
            ></i>
            <p style="margin: 0; font-size: 7px">Wishlist</p>
          </div>
          <div
            class="flex flex-column justify-content-center align-items-center"
          >
            <i
              v-if="headerCartIcon"
              class="fa fa-shopping-cart"
              style="font-size: 11px"
            ></i>
            <p style="margin: 0; font-size: 7px">Cart</p>
          </div>
        </div>
      </div>
      <div class="body-mob" :style="`color:${primaryTextColor};`">
        <div class="advertisement">
          <img
            src="https://fastforge-dev.s3.amazonaws.com/images/advertisement/mdx7q8uovo7l1"
            alt=""
            class="sales-advertisement"
          />
        </div>
        <div :style="`background: ${primaryLightColor}`" class="toy-categories">
          <div class="header-section">
            <h1 :style="`color:${primaryTextColor};`" class="title">
              Shop by Category
            </h1>
            <p :style="`color:${primaryTextColor};`" class="subtitle">
              Choose from our wide variety of fresh produce
            </p>
          </div>
          <div class="carousel-wrapper">
            <!-- Left Arrow -->
            <button class="carousel-arrow left">
              <i class="fa fa-chevron-left"></i>
            </button>

            <!-- Carousel Items -->
            <div class="item-logos" v-if="categorySection">
              <div class="item">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s" alt="" />
              </div>
              <div class="item">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s" alt="" />
              </div>
              <div class="item">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s" alt="" />
              </div>
              <div class="item">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s" alt="" />
              </div>
            </div>

            <!-- Right Arrow -->
            <button class="carousel-arrow right">
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>

        <div class="mt-3 mb-3 flex justify-content-between align-items-center">
          <div :style="`color: ${primaryTextColor};`">
            <p class="new-store-labels">Today's Best Deals</p>
            <span class="new-store-sub-labels"
              >Limited time offers on fresh produce</span
            >
          </div>

          <button
            :style="`color: #fff; background: ${primaryColor}; gap: 4px;`"
            class="deal-btn"
          >
            View All Deals <i class="fa fa-arrow-right"></i>
          </button>
        </div>
        <div class="product-grid">
          <div
            class="product-card"
            v-for="(item, index) in products"
            :key="index"
          >
            <!-- Icons -->
            <div class="card-icons">
              <i style="color: red" class="fa fa-heart-o"></i>
              <i style="color: green" class="fa fa-eye"></i>
            </div>

            <!-- Product Image -->
            <img :src="item.img" :alt="item.name" class="product-img" />

            <!-- Product Info -->
            <div class="product-info">
              <h5 :style="`color:${primaryTextColor};`" class="product-title">
                {{ item.name }}
              </h5>
              <p :style="`color:${primaryTextColor};`" class="product-sub">
                {{ item.vendor }}
              </p>
              <p :style="`color:${primaryTextColor};`" class="product-price">
                ${{ item.price }}
              </p>
              <button
                :style="`color: #fff; background: linear-gradient(135deg, ${primaryColor}, ${primaryGradient});`"
                class="add-btn"
              >
                <i class="fa fa-shopping-cart"></i>
                <span class="add-btn-text"> Add to Cart</span>
              </button>
            </div>
          </div>
        </div>
        <div class="advertisement">
          <img
            src="https://fastforge-dev.s3.amazonaws.com/images/advertisement/me84d6j6h2wqv"
            alt=""
            class="sales-advertisement"
          />
        </div>
        <div
          :style="`color:${primaryTextColor};`"
          class="mb-3 mt-3 flex flex-column justify-content-center align-items-center"
        >
          <p class="new-store-labels">Popular This Week</p>
          <span class="new-store-sub-labels">Most loved by our customers</span>
        </div>
        <div class="product-grid">
          <div
            class="product-card"
            v-for="(item, index) in products"
            :key="index"
          >
            <!-- Icons -->
            <div class="card-icons">
              <i style="color: red" class="fa fa-heart-o"></i>
              <i style="color: green" class="fa fa-eye"></i>
            </div>

            <!-- Product Image -->
            <img :src="item.img" :alt="item.name" class="product-img" />

            <!-- Product Info -->
            <div class="product-info">
              <h5 :style="`color:${primaryTextColor};`" class="product-title">
                {{ item.name }}
              </h5>
              <p :style="`color:${primaryTextColor};`" class="product-sub">
                {{ item.vendor }}
              </p>
              <p :style="`color:${primaryTextColor};`" class="product-price">
                ${{ item.price }}
              </p>
              <button
                :style="`color: #fff; background: linear-gradient(135deg, ${primaryColor}, ${primaryGradient});`"
                class="add-btn"
              >
                <i class="fa fa-shopping-cart"></i>
                <span class="add-btn-text"> Add to Cart</span>
              </button>
            </div>
          </div>
        </div>
        <div class="mt-2 product-grid">
          <div
            class="product-card"
            v-for="(item, index) in products"
            :key="index"
          >
            <!-- Icons -->
            <div class="card-icons">
              <i style="color: red" class="fa fa-heart-o"></i>
              <i style="color: green" class="fa fa-eye"></i>
            </div>

            <!-- Product Image -->
            <img :src="item.img" :alt="item.name" class="product-img" />

            <!-- Product Info -->
            <div class="product-info">
              <h5 :style="`color:${primaryTextColor};`" class="product-title">
                {{ item.name }}
              </h5>
              <p :style="`color:${primaryTextColor};`" class="product-sub">
                {{ item.vendor }}
              </p>
              <p :style="`color:${primaryTextColor};`" class="product-price">
                ${{ item.price }}
              </p>
              <button
                :style="`color: #fff; background: linear-gradient(135deg, ${primaryColor}, ${primaryGradient});`"
                class="add-btn"
              >
                <i class="fa fa-shopping-cart"></i>
                <span class="add-btn-text"> Add to Cart</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="m-4"></div>
      <!-- Update the footer section in template -->
      <!-- Footer Section as per screenshot -->
      <div
        :style="`background: ${footerBgColor}; color: ${footerTextColor}; padding: 16px 12px 16px 12px; font-size: 9px;`"
      >
        <div
          style="
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 8px;
          "
        >
          <!-- About Us -->
          <div style="flex: 1 1 210px; min-width: 210px; margin-bottom: 12px">
            <div
              style="
                font-size: 14px;
                font-weight: bold;
                display: flex;
                align-items: center;
                gap: 4px;
              "
            >
              <img
                :src="appIcon || require('@/assets/images/mob-default-img.svg')"
                style="height: 20px"
                alt="logo"
              />
              {{ appName }}
            </div>
            <div
              style="
                font-size: 8px;
                margin-bottom: 4px;
                margin-top: 4px;
                letter-spacing: 0.6px;
              "
            >
              {{ tagLine }}
            </div>
            <div style="margin-bottom: 8px; font-size: 9px; line-height: 1.2">
              Trusted partner for fresh, organic fruits & vegetables. Sourced
              locally and delivered with love.
            </div>
          </div>

          <!-- The three sections in one row -->
          <div
            style="display: flex; justify-content: space-between; width: 100%"
          >
            <!-- Shop Categories -->
            <div style="margin-right: 8px">
              <div
                style="
                  font-weight: bold;
                  display: flex;
                  align-items: center;
                  gap: 4px;
                  font-size: 10px;
                  margin-bottom: 6px;
                "
              >
                <i class="fa fa-shopping-basket" style="font-size: 12px"></i>
                Shop Categories
              </div>
              <ul
                style="
                  list-style: none;
                  padding: 0;
                  font-size: 9px;
                  line-height: 1.2;
                "
              >
                <li style="margin-bottom: 4px">
                  <i
                    class="fa fa-apple"
                    style="margin-right: 4px; font-size: 9px"
                  ></i>
                  Fresh Fruits
                </li>
                <li style="margin-bottom: 4px">
                  <i
                    class="fa fa-leaf"
                    style="margin-right: 4px; font-size: 9px"
                  ></i>
                  Fresh Veggies
                </li>
                <li>
                  <i
                    class="fa fa-envira"
                    style="margin-right: 4px; font-size: 9px"
                  ></i>
                  Herbs & Seasonings
                </li>
              </ul>
            </div>

            <!-- Customer Care -->
            <div style="margin-right: 8px">
              <div
                style="
                  font-weight: bold;
                  display: flex;
                  align-items: center;
                  gap: 4px;
                  font-size: 10px;
                  margin-bottom: 6px;
                "
              >
                <i class="fa fa-life-ring" style="font-size: 12px"></i> Customer
                Care
              </div>
              <ul
                style="
                  list-style: none;
                  padding: 0;
                  font-size: 9px;
                  line-height: 1.2;
                "
              >
                <li style="margin-bottom: 4px">My Orders</li>
                <li style="margin-bottom: 4px">Help Center</li>
                <li style="margin-bottom: 4px">Returns & Refunds</li>
                <li style="margin-bottom: 4px">Contact Us</li>
                <li style="margin-bottom: 4px">Live Chat Support</li>
                <li>FAQ</li>
              </ul>
            </div>

            <!-- Get in Touch -->
            <div style="">
              <div
                style="
                  font-weight: bold;
                  display: flex;
                  align-items: center;
                  gap: 4px;
                  font-size: 10px;
                  margin-bottom: 6px;
                "
              >
                <i class="fa fa-phone" style="font-size: 12px"></i> Get in Touch
              </div>
              <div style="margin-bottom: 6px; font-size: 9px; line-height: 1.2">
                <strong>Customer Service</strong><br />
                <span style="font-size: 8px">+91 98765 43210</span><br />
                <span style="font-size: 7px">Mon-Sun: 6 AM - 11 PM</span>
              </div>
              <div style="margin-bottom: 6px; font-size: 9px; line-height: 1.2">
                <strong
                  ><i
                    class="fa fa-envelope"
                    style="margin-right: 3px; font-size: 12px"
                  ></i
                  >Email Support</strong
                ><br />
                <span style="font-size: 8px">support@freshharvest.com</span
                ><br />
                <span style="font-size: 7px">24/7 Email Support</span>
              </div>
              <div style="font-size: 9px; line-height: 1.2">
                <strong
                  ><i
                    class="fa fa-map-marker"
                    style="margin-right: 3px; font-size: 12px"
                  ></i>
                  Headquarters</strong
                ><br />
                123 Farm Street, Mumbai<br />
                Maharashtra, India 400001
              </div>
            </div>
          </div>
        </div>

        <!-- Footer bottom bar -->
        <div
          style="
            margin-top: 12px;
            border-top: 1px solid #205768;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            padding-top: 8px;
            font-size: 8px;
          "
        >
          <div>
            © 2024 {{ appName }}. All rights reserved.
            <span style="margin-left: 10px"
              ><a style="text-decoration: none">Privacy Policy</a></span
            >
            <span style="margin-left: 6px"
              ><a style="text-decoration: none">Terms of Service</a></span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Note The icon need to be black for colour change to work

class Color {
  constructor(r, g, b) {
    this.set(r, g, b);
  }

  toString() {
    return `rgb(${Math.round(this.r)}, ${Math.round(this.g)}, ${Math.round(
      this.b
    )})`;
  }

  set(r, g, b) {
    this.r = this.clamp(r);
    this.g = this.clamp(g);
    this.b = this.clamp(b);
  }

  hueRotate(angle = 0) {
    angle = (angle / 180) * Math.PI;
    const sin = Math.sin(angle);
    const cos = Math.cos(angle);

    this.multiply([
      0.213 + cos * 0.787 - sin * 0.213,
      0.715 - cos * 0.715 - sin * 0.715,
      0.072 - cos * 0.072 + sin * 0.928,
      0.213 - cos * 0.213 + sin * 0.143,
      0.715 + cos * 0.285 + sin * 0.14,
      0.072 - cos * 0.072 - sin * 0.283,
      0.213 - cos * 0.213 - sin * 0.787,
      0.715 - cos * 0.715 + sin * 0.715,
      0.072 + cos * 0.928 + sin * 0.072,
    ]);
  }

  grayscale(value = 1) {
    this.multiply([
      0.2126 + 0.7874 * (1 - value),
      0.7152 - 0.7152 * (1 - value),
      0.0722 - 0.0722 * (1 - value),
      0.2126 - 0.2126 * (1 - value),
      0.7152 + 0.2848 * (1 - value),
      0.0722 - 0.0722 * (1 - value),
      0.2126 - 0.2126 * (1 - value),
      0.7152 - 0.7152 * (1 - value),
      0.0722 + 0.9278 * (1 - value),
    ]);
  }

  sepia(value = 1) {
    this.multiply([
      0.393 + 0.607 * (1 - value),
      0.769 - 0.769 * (1 - value),
      0.189 - 0.189 * (1 - value),
      0.349 - 0.349 * (1 - value),
      0.686 + 0.314 * (1 - value),
      0.168 - 0.168 * (1 - value),
      0.272 - 0.272 * (1 - value),
      0.534 - 0.534 * (1 - value),
      0.131 + 0.869 * (1 - value),
    ]);
  }

  saturate(value = 1) {
    this.multiply([
      0.213 + 0.787 * value,
      0.715 - 0.715 * value,
      0.072 - 0.072 * value,
      0.213 - 0.213 * value,
      0.715 + 0.285 * value,
      0.072 - 0.072 * value,
      0.213 - 0.213 * value,
      0.715 - 0.715 * value,
      0.072 + 0.928 * value,
    ]);
  }

  multiply(matrix) {
    const newR = this.clamp(
      this.r * matrix[0] + this.g * matrix[1] + this.b * matrix[2]
    );
    const newG = this.clamp(
      this.r * matrix[3] + this.g * matrix[4] + this.b * matrix[5]
    );
    const newB = this.clamp(
      this.r * matrix[6] + this.g * matrix[7] + this.b * matrix[8]
    );
    this.r = newR;
    this.g = newG;
    this.b = newB;
  }

  brightness(value = 1) {
    this.linear(value);
  }
  contrast(value = 1) {
    this.linear(value, -(0.5 * value) + 0.5);
  }

  linear(slope = 1, intercept = 0) {
    this.r = this.clamp(this.r * slope + intercept * 255);
    this.g = this.clamp(this.g * slope + intercept * 255);
    this.b = this.clamp(this.b * slope + intercept * 255);
  }

  invert(value = 1) {
    this.r = this.clamp((value + (this.r / 255) * (1 - 2 * value)) * 255);
    this.g = this.clamp((value + (this.g / 255) * (1 - 2 * value)) * 255);
    this.b = this.clamp((value + (this.b / 255) * (1 - 2 * value)) * 255);
  }

  hsl() {
    // Code taken from https://stackoverflow.com/a/9493060/2688027, licensed under CC BY-SA.
    const r = this.r / 255;
    const g = this.g / 255;
    const b = this.b / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h,
      s,
      l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;

        case g:
          h = (b - r) / d + 2;
          break;

        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    return {
      h: h * 100,
      s: s * 100,
      l: l * 100,
    };
  }

  clamp(value) {
    if (value > 255) {
      value = 255;
    } else if (value < 0) {
      value = 0;
    }
    return value;
  }
}

class Solver {
  constructor(target, baseColor) {
    this.target = target;
    this.targetHSL = target.hsl();
    this.reusedColor = new Color(0, 0, 0);
  }

  solve() {
    const result = this.solveNarrow(this.solveWide());
    return {
      values: result.values,
      loss: result.loss,
      filter: this.css(result.values),
    };
  }

  solveWide() {
    const A = 5;
    const c = 15;
    const a = [60, 180, 18000, 600, 1.2, 1.2];

    let best = { loss: Infinity };
    for (let i = 0; best.loss > 25 && i < 3; i++) {
      const initial = [50, 20, 3750, 50, 100, 100];
      const result = this.spsa(A, a, c, initial, 1000);
      if (result.loss < best.loss) {
        best = result;
      }
    }
    return best;
  }

  solveNarrow(wide) {
    const A = wide.loss;
    const c = 2;
    const A1 = A + 1;
    const a = [0.25 * A1, 0.25 * A1, A1, 0.25 * A1, 0.2 * A1, 0.2 * A1];
    return this.spsa(A, a, c, wide.values, 500);
  }

  spsa(A, a, c, values, iters) {
    const alpha = 1;
    const gamma = 0.16666666666666666;

    let best = null;
    let bestLoss = Infinity;
    const deltas = new Array(6);
    const highArgs = new Array(6);
    const lowArgs = new Array(6);

    for (let k = 0; k < iters; k++) {
      const ck = c / Math.pow(k + 1, gamma);
      for (let i = 0; i < 6; i++) {
        deltas[i] = Math.random() > 0.5 ? 1 : -1;
        highArgs[i] = values[i] + ck * deltas[i];
        lowArgs[i] = values[i] - ck * deltas[i];
      }

      const lossDiff = this.loss(highArgs) - this.loss(lowArgs);
      for (let i = 0; i < 6; i++) {
        const g = (lossDiff / (2 * ck)) * deltas[i];
        const ak = a[i] / Math.pow(A + k + 1, alpha);
        values[i] = fix(values[i] - ak * g, i);
      }

      const loss = this.loss(values);
      if (loss < bestLoss) {
        best = values.slice(0);
        bestLoss = loss;
      }
    }
    return { values: best, loss: bestLoss };

    function fix(value, idx) {
      let max = 100;
      if (idx === 2 /* saturate */) {
        max = 7500;
      } else if (idx === 4 /* brightness */ || idx === 5 /* contrast */) {
        max = 200;
      }

      if (idx === 3 /* hue-rotate */) {
        if (value > max) {
          value %= max;
        } else if (value < 0) {
          value = max + (value % max);
        }
      } else if (value < 0) {
        value = 0;
      } else if (value > max) {
        value = max;
      }
      return value;
    }
  }

  loss(filters) {
    // Argument is array of percentages.
    const color = this.reusedColor;
    color.set(0, 0, 0);

    color.invert(filters[0] / 100);
    color.sepia(filters[1] / 100);
    color.saturate(filters[2] / 100);
    color.hueRotate(filters[3] * 3.6);
    color.brightness(filters[4] / 100);
    color.contrast(filters[5] / 100);

    const colorHSL = color.hsl();
    return (
      Math.abs(color.r - this.target.r) +
      Math.abs(color.g - this.target.g) +
      Math.abs(color.b - this.target.b) +
      Math.abs(colorHSL.h - this.targetHSL.h) +
      Math.abs(colorHSL.s - this.targetHSL.s) +
      Math.abs(colorHSL.l - this.targetHSL.l)
    );
  }

  css(filters) {
    function fmt(idx, multiplier = 1) {
      return Math.round(filters[idx] * multiplier);
    }
    return `filter: invert(${fmt(0)}%) sepia(${fmt(1)}%) saturate(${fmt(
      2
    )}%) hue-rotate(${fmt(3, 3.6)}deg) brightness(${fmt(4)}%) contrast(${fmt(
      5
    )}%);`;
  }
}

export default {
  data() {
    return {
      currentIndex: 0,
      itemsPerPage: 5,
      categories: [
        {
          id: 1,
          name: "Action & Collectibles",
          icon: "/placeholder.svg?height=60&width=60",
          color: "#8B5CF6",
        },
        {
          id: 2,
          name: "Baby & Toddler",
          icon: "/placeholder.svg?height=60&width=60",
          color: "#EC4899",
        },
        {
          id: 3,
          name: "Building Sets",
          icon: "/placeholder.svg?height=60&width=60",
          color: "#F97316",
        },
        {
          id: 4,
          name: "Creative & DIY",
          icon: "/placeholder.svg?height=60&width=60",
          color: "#EAB308",
        },
        {
          id: 5,
          name: "Dolls & Role Play",
          icon: "/placeholder.svg?height=60&width=60",
          color: "#22C55E",
        },
        {
          id: 6,
          name: "Educational",
          icon: "/placeholder.svg?height=60&width=60",
          color: "#3B82F6",
        },
        {
          id: 7,
          name: "Outdoor & Sports",
          icon: "/placeholder.svg?height=60&width=60",
          color: "#EF4444",
        },
      ],
      products: [
        {
          name: "Apple43 - 2 LLB",
          price: 350,
          img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
          vendor: "FreshPickHub",
        },
        {
          name: "Dragon Fruits",
          price: 350,
          img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
          vendor: "FreshPickHub",
        },
        {
          name: "Tomato - 2LB",
          price: 350,
          img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
          vendor: "FreshPickHub",
        },
      ],
    };
  },
  props: {
    font: {
      type: String,
      default: "",
    },
    primaryColor: {
      type: String,
      default: "#ffffff",
    },
    primaryTextColor: {
      type: String,
      default: "#000000",
    },
    primaryLightColor: {
      type: String,
      default: "#ffffff",
    },
    primaryGradient: {
      type: String,
      default: "#ffffff",
    },
    statusBar: {
      type: String,
      default: "#ffffff",
    },
    headerBottom: {
      type: String,
      default: "#ffffff",
    },
    headerFont: {
      type: String,
      default: "#ffffff",
    },
    footerBgColor: {
      type: String,
      default: "#ffffff",
    },
    footerTextColor: {
      type: String,
      default: "#ffffff",
    },
    appIcon: {
      type: String,
      default: null,
    },
    appName: {
      type: String,
      default: "App Name",
    },
    tagLine: {
      type: String,
      default: "Tagline",
    },
    btnColour: {
      type: String,
      default: "#0b4990",
    },
    headerCartIcon: {
      type: Boolean,
      default: true,
    },
    headerWishlistIcon: {
      type: Boolean,
      default: true,
    },
    headerNavs: {
      type: Boolean,
      default: true,
    },
    businessKeyPoints: {
      type: Boolean,
      default: true,
    },
    categorySection: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    nextSlide() {
      if (this.currentIndex < this.categories.length - this.itemsPerPage) {
        this.currentIndex += 1;
      }
    },
    previousSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1;
      }
    },
    hexToRgb(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, (m, r, g, b) => {
        return r + r + g + g + b + b;
      });

      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? [
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16),
          ]
        : null;
    },
    changeToColor(col) {
      const rgb = this.hexToRgb(col);

      const color = new Color(rgb[0], rgb[1], rgb[2]);
      const solver = new Solver(color);
      const result = solver.solve();
      return result.filter;
    },

    //based on the button background hex color, calculate the luminance/ brightness of the color
    getLuminance(hexColor) {
      const rgb = this.hexToRgb(hexColor);
      if (!rgb) return 0;

      // Calculate relative luminance using WCAG formula
      const [r, g, b] = rgb.map((c) => {
        c = c / 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
      });
      return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    },
  },
  computed: {
    visibleCategories() {
      return this.categories.slice(
        this.currentIndex,
        this.currentIndex + this.itemsPerPage
      );
    },
    totalDots() {
      return Math.ceil(this.categories.length / this.itemsPerPage);
    },
    buttonTextColor() {
      const luminance = this.getLuminance(this.btnColour);
      return luminance > 0.5 ? "#000000" : "#ffffff";
    },
    buttonStyle() {
      return {
        "--btn-color": this.btnColour,
        "--btn-text-color": this.buttonTextColor,
      };
    },
    headerIconStyle() {
      return this.changeToColor(this.primaryTextColor);
    },
    // footerNormalStyle() {
    //   return this.changeToColor(this.footerNormal);
    // },
    // footerSelStyle() {
    //   return this.changeToColor(this.footerSelection);
    // },
    splashBGStyle() {
      if (this.splashBGImage) {
        return `background-image:url(${this.splashBGImage});background-color:${this.splashBGCol};`;
      }
      return `background:${this.splashBGCol};`;
    },
  },
  mounted() {
    this.changeToColor("#aa44bb");
  },
};
</script>

<style lang="scss" scoped>
.laptop-body {
  width: 500px;
  height: 290px;
  background: white;
  position: relative;
  z-index: 10;
  font-size: 10px;
  overflow-y: auto; // Changed from overflow: hidden
  overflow-x: hidden; // Prevent horizontal scrolling
}

.header-mob {
  width: 100%;
  height: 45px;
  border-radius: 0;
  padding: 5px 15px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0px 2.2637px 5.65925px rgba(0, 0, 0, 0.15);
}

.status-bar {
  display: flex;
  justify-content: space-between;
  padding: 6px 10px;

  font-size: 8px;
  font-weight: 550;
}

.filter-bar {
  margin: 5px 10px;
  color: #979797;
  font-size: 6px;
}

.search-bar-large {
  width: 120px;
  padding: 2px 5px;
  background: white;
  vertical-align: middle;
  border-radius: 10px;
  display: inline-block;
}

.change-my-color {
  fill: green;
}

.sales-advertisement {
  margin: 8px auto;
  display: block;
  max-height: 230px;
}

img.sales-advertisement {
  width: 100%;
}

.item-logos {
  display: flex;
  padding: 12px;
  margin: 5px 30px;

  .item {
    background: #fff;
    border-radius: 6px;
    img {
      height: 55px;
      padding: 0 15px;
    }

    display: flex;
    margin: 0 9px;
    font-size: 7.5px;
    flex-direction: column;
    align-items: center;
  }
}
.carousel-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  border-radius: 50%;
  border: none;
  width: 30px;
  height: 30px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.carousel-arrow.left {
  left: 30px;
}

.carousel-arrow.right {
  right: 30px;
}
.new-store-labels {
  font-size: 18px;
  font-weight: 600;
  margin: 0 20px;
  display: flex;
  justify-content: space-between;
}

.new-store-sub-labels {
  font-size: 10px;
  font-weight: 400;
  margin: 0 20px;
}

.laptop-frame {
  position: absolute;
  z-index: 2;
  bottom: -59px;
  left: -122.5px;

  img {
    display: block;
    width: 745px;
    height: 358px;
    object-fit: fill;
  }
}

.app-logo {
  font-size: 8px;

  img {
    width: 25px;
  }
}

.advertisement {
  position: relative;
}

// .label-1 {
//   position: absolute;
//   top: 15px;
//   z-index: 2;
//   color: #0b4990;
//   font-size: 20px;
//   right: 15px;
//   font-weight: 600;
// }

// .label-2 {
//   position: absolute;
//   top: 42px;
//   z-index: 2;
//   color: #0b4990;
//   font-size: 12px;
//   right: 15px;
//   font-weight: 500;

//   span {
//     color: #fe7b08;
//   }
// }

.call {
  position: absolute;
  right: 15px;
  top: 189px;
}

.scroll {
  position: absolute;
  right: 15px;
  top: 209px;
}

.rightside {
  position: absolute;
  right: 26px;
  top: 200px;
}

.leftside {
  position: absolute;
  left: 26px;
  top: 200px;
  transform: rotateZ(180deg);
}

/* identical to box height */

/* Store */
.store {
  font-style: normal;
  padding: 3px 6px;
  font-weight: 400;
  font-size: 4.0371px;
  line-height: 6px;
  color: #ffffff;
}

/* identical to box height */
.laptop-body::-webkit-scrollbar {
  width: 6px;
}

.laptop-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.laptop-body::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.laptop-body::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.footer-content ul {
  margin-bottom: 0;
  padding: 10px 0;
  text-align: center;
}

.footer-content ul li {
  display: inline-block;
  margin: 0 20px;
}

.about-us {
  width: 100px;
}

.footer-bottom {
  padding: 10px 0;
  text-align: center;
}

.payment-methods {
  display: flex;
  gap: 10px;
}

.payment-methods img {
  height: 100%;
  width: 40px;
}

.loginbtns {
  font-size: 10px;
  background: var(--btn-color);
  color: var(--btn-text-color);
  padding: 4px 8px;
  border-radius: 5px;
}

.customerBanner {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 40px 0 rgba(0, 38, 3, 0.0784313725490196);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 20px;
  padding: 10px;
  margin-bottom: 20px;
  padding-bottom: 0;
}

.shippingArea {
  display: flex;
  align-items: center;
}

.shippingArea img {
  width: 20px;
}

.shippingArea h5 {
  font-size: 9px;
  margin-bottom: 0;
}

.shippingArea p {
  font-size: 8px;
}

.newArrivalMain {
  display: flex;
  justify-content: flex-start;
  margin: 10px 20px;
}

.newArrivalSec {
  border: 1px solid #dfdfdf;
  padding: 10px;
  width: 24%;
}

.newArrivalSec img {
  width: 45px;
  height: 45px;
  margin: 0 auto;
  display: block;
}

.newArrivalSec h5 {
  font-size: 10px;
  margin-bottom: 5px;
}

.newArrivalSec p {
  font-size: 10px;
  margin-bottom: 5px;
}

.newArrivalSec span {
  border-radius: 50px;
}

.newArrivalSec i {
  float: right;
}

toy-categories {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  text-align: center;
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
  min-height: 400px;
}

.header-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #f97316;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(249, 115, 22, 0.1);
}

.subtitle {
  font-size: 1.125rem;
  color: #f97316;
  opacity: 0.8;
  margin: 0;
}

.carousel-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 2rem;
}

.nav-button {
  background: white;
  border: 2px solid #f97316;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: #f97316;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(249, 115, 22, 0.15);
}

.nav-button:hover:not(:disabled) {
  background: #f97316;
  color: white;
  transform: scale(1.05);
}

.nav-button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.categories-grid {
  display: flex;
  gap: 2rem;
  align-items: center;
}

.category-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  transition: transform 0.3s ease;
}

.category-item:hover {
  transform: translateY(-4px);
}

.category-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 3px solid;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.category-circle:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  transform: scale(1.05);
}

.category-icon {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.category-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: #f97316;
  margin: 0;
  max-width: 100px;
  line-height: 1.2;
}

.dots-indicator {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f97316;
  opacity: 0.3;
  transition: opacity 0.3s ease;
}

.dot.active {
  opacity: 1;
}

@media (max-width: 768px) {
  .toy-categories {
    padding: 1rem;
  }

  .title {
    font-size: 2rem;
  }

  .categories-grid {
    gap: 1rem;
  }

  .category-circle {
    width: 60px;
    height: 60px;
  }

  .category-icon {
    width: 36px;
    height: 36px;
  }

  .category-name {
    font-size: 0.75rem;
    max-width: 80px;
  }
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 8px;
  margin: 0 8px;
}

.product-card {
  position: relative;
  background: #fff;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s;
  border: #e4e4e4 solid 1px;
}

.product-card:hover {
  transform: translateY(-4px);
}

.card-icons {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-icons i {
  background: #fff;
  border-radius: 50%;
  padding: 8px;
  font-size: 12px;
  cursor: pointer;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
}

.product-img {
  width: 100%;
  height: 115px;
  object-fit: cover;
  background: #f9f9f9;
}

.product-info {
  padding: 12px;
  text-align: left;
}

.product-title {
  font-size: 11px;
  font-weight: 600;
  margin: 0;
}

.product-sub {
  font-size: 9px;
  color: #888;
  margin: 4px 0;
}

.product-price {
  font-size: 11px;
  color: #16a34a;
  font-weight: bold;
  margin: 2px 0;
}

.add-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 5px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.add-btn:hover {
  opacity: 0.9;
}
.add-btn-text {
  font-size: 9px;
}
.deal-btn {
  background: #388e3c; /* or use the exact green you need */
  border: none;
  border-radius: 9px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  height: 30px;
  margin-right: 10px;
  transition: background 0.2s;
}
.arrow {
  font-size: 18px;
  margin-left: 8px;
  font-weight: 700;
  display: inline-block;
  transform: translateY(1px);
}
.account-icon {
  width: 25px;
  height: 25px;
  margin-right: 5px;
  background: #f1f5f9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}
</style>
